import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'style.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
const Term = () => {
  const html = ` 
  <main>
  <section class="container mb-md-custom-xxl first-section align-items-center">
    <div class="row mb-md-custom-xxl align-items-center">
      <div class="col-12 col-md-6">
        <h3 class="mb-2">Terms of platform use</h3>
        <p class="mb-custom-lg text-gray">
          This terms of use (together with the documents referred to in it) tells you the terms of use on which you
          may make use of our platform efun.tech, whether as a guest or a user with a connected wallet. Use of our
          platform includes accessing, browsing, or connecting to use our platform. Please read these terms of use
          carefully before you start to use our platform, as these will apply to your use of our platform. We
          recommend that you print a copy of this for future reference.<br />
          By using our platform, you confirm that you accept these terms of use and that you agree to comply with
          them. If you do not agree to these terms of use, you must not use our platform.
        </p>
        <h3 class="mb-2">Other applicable terms</h3>
        <p class="mb-custom-lg text-gray">
          These terms of use refer to the following additional terms, which also apply to your use of our
          platform.<br />
          Our Privacy Policy which sets out the terms on which we process any personal data we collect from you, or
          that you provide to us. By using our platform, you consent to such processing and you warrant that all data
          provided by you is accurate.
        </p>
        <h3 class="mb-2">Changes to these terms</h3>
        <p class="mb-custom-lg text-gray">
          We may revise these terms of use at any time by amending this page. Please check this page from time to time
          to take notice of any changes we made, as they are binding on you.
        </p>
        <h3 class="mb-2">Changes to our platform</h3>
        <p class="text-gray">
          We may update our platform from time to time, and may change the content at any time. However, please note
          that any of the content on our platform may be out of date at any given time, and we are under no obligation
          to update it. We do not guarantee that our platform, or any content on it, will be free from errors or
          omissions.
        </p>
      </div>
      <div class="col-12 col-md-6">
        <div class="d-flex justify-content-md-end">
          <img class="img-fluid mb-custom-lg mb-md-0" src="https://efun-public.s3.ap-southeast-1.amazonaws.com/images/term-1.svg" alt="home item right" />
        </div>
      </div>
    </div>
    <div class="row flex-column-reverse flex-md-row mb-md-custom-xxl align-items-center">
      <div class="col-12 col-md-6">
        <div class="d-flex justify-content-md-start">
          <img class="img-fluid mb-custom-lg mb-md-0" src="https://efun-public.s3.ap-southeast-1.amazonaws.com/images/term-2.svg" alt="home item right" />
        </div>
      </div>
      <div class="col-12 col-md-6">
        <h3 class="mb-2">Accessing our platform</h3>
        <p class="mb-custom-lg text-gray">
          Online wagering or gambling is an activity reserved only for adults. This platform is not marketed to or intended for minors or anyone lacking the legal capacity to participate in online wagering or gambling, or even prediction activities.
        <br />
          Anyone under 18 years of age is strictly forbidden from using this platform or its services.<br />
          Our platform is made available free of charge. We do not guarantee that our platform, or any content on it,
          will always be available or be uninterrupted. Access to our platform is permitted on a temporary basis. We
          may suspend, withdraw, discontinue or change all or any part of our platform without notice. We will not be
          liable to you if for any reason our platform is unavailable at any time or for any period.<br />
          You are responsible for making all arrangements necessary for you to have access to our platform. You are
          also responsible for ensuring that all persons who access our platform through your internet connection are
          aware of these terms of use and other applicable terms and conditions, and that they comply with them.<br />
          Our platform is directed to people residing in the territories that allow gambling and wagering online. We do not represent that content available on or through our platform is appropriate or available in other locations. We may limit the availability of our platform or any service or product described on our platform to any person or geographic area at any time. If you choose to access our platform from outside the territories that allow gambling and gambling online, you do so at your own risk
        </p>
        <h3 class="mb-2">Your account and password</h3>
        <p class="mb-custom-lg text-gray">
          These terms of use refer to the following additional terms, which also apply to your use of our
          platform.<br />
          Our Privacy Policy which sets out the terms on which we process any personal data we collect from you, or
          that you provide to us. By using our platform, you consent to such processing and you warrant that all data
          provided by you is accurate.
        </p>
        <h3 class="mb-2">Intellectual property rights</h3>
        <p class="mb-custom-lg text-gray">
          We are the owner or the licensee of all intellectual property rights in our platform, and in the material
          published on it. Those works are protected by copyright laws and treaties around the world. All such rights
          are reserved. You may print off one copy, and may download extracts, of any page(s) from our platform for
          your personal use and you may draw the attention of others within your organization to content posted on our
          platform. You must not modify the paper or digital copies of any materials you have printed off or
          downloaded in any way, and you must not use any illustrations, photographs, video or audio sequences or any
          graphics separately from any accompanying text. Our status (and that of any identified contributors) as the
          authors of content on our platform must always be acknowledged. You must not use any part of the content on
          our platform for commercial purposes without obtaining a license to do so from us or our licensors.<br />
          If you print off, copy or download any part of our platform in breach of these terms of use, your right to
          use our platform will cease immediately and you must, at our option, return or destroy any copies of the
          materials you have made.
        </p>
      </div>
    </div>
    <div class="row mb-md-custom-xxl align-items-center">
      <div class="col-12 col-md-6">
        <h3 class="mb-2">No reliance on information</h3>
        <p class="mb-custom-lg text-gray">
          The content on our platform is provided for general information only. It is not intended to amount to advice
          on which you should rely. You must obtain professional or specialist advice before taking, or refraining
          from, any action on the basis of the content on our platform. Although we make reasonable efforts to update
          the information on our platform, we make no representations, warranties or guarantees, whether expressed or
          implied, that the content on our platform is accurate, complete or up-to-date.
        </p>
        <h3 class="mb-2">Limitation of our liability</h3>
        <p class="mb-custom-lg text-gray">
          Nothing in these terms of use excludes or limits our liability for death or personal injury arising from our
          negligence, or our fraud or fraudulent misrepresentation, or any other liability that cannot be excluded or
          limited. To the extent permitted by applicable law, we exclude all conditions, warranties, representations
          or other terms which may apply to our platform, or any content on it, whether expressed or implied. We will
          not be liable to any user for any loss or damage, whether in contract, tort (including negligence), breach
          of statutory duty, or otherwise, even if foreseeable, arising under or in connection with:<br />
          • use of, or inability to use, our platform; or<br />
          • use of or reliance on any content displayed on our platform. If you are a business user, please note that
          in particular, we will not be liable for:<br />
          • loss of profits, sales, business, or revenue;<br />
          • business interruption;<br />
          • loss of anticipated savings;<br />
          • loss of business opportunity, goodwill or reputation; or<br />
          • any indirect or consequential loss or damage.<br />
          We will not be liable for any loss or damage caused by a virus, distributed denial-of-service attack, or
          other technologically harmful material that may infect your computer equipment, computer programs, data or
          other proprietary material due to your use of our platform or to your downloading of any content on it, or
          on any website linked to it. We assume no responsibility for the content of websites linked on our platform.
          Such links should not be interpreted as endorsement by us of those linked websites. We will not be liable
          for any loss or damage that may arise from your use of them.
        </p>
      </div>
      <div class="col-12 col-md-6">
        <div class="d-flex justify-content-md-end">
          <img class="img-fluid mb-custom-lg mb-md-0" src="https://efun-public.s3.ap-southeast-1.amazonaws.com/images/term-3.svg" alt="home item right" />
        </div>
      </div>
    </div>
    <div class="row flex-column-reverse flex-md-row align-items-center">
      <div class="col-12 col-md-6">
        <div class="d-flex justify-content-md-start">
          <img class="img-fluid mb-custom-lg mb-md-0" src="https://efun-public.s3.ap-southeast-1.amazonaws.com/images/term-4.svg" alt="home item right" />
        </div>
      </div>
      <div class="col-12 col-md-6">
        <h3 class="mb-2">Uploading content to our platform</h3>
        <p class="mb-custom-lg text-gray">
          Whenever you make use of a feature that allows you to upload content to our platform, or to make contact
          with other users of our platform, you must comply with the content standards set out by us. You warrant that
          any such contribution does comply with those standards, and you will be liable to us and indemnify us for
          any breach of that warranty. Any content you upload to our platform will be considered non-confidential and
          non-proprietary. You retain all of your ownership rights in your content, but you are required to grant us
          and other users of the platform a limited license to use, store and copy that content and to distribute and
          make it available to third parties.<br />
          The rights you license to us are described in the next paragraph (Rights you license). We also have the
          right to disclose your wallet address to any third party who is claiming that any content posted or uploaded
          by you to our platform constitutes a violation of their intellectual property rights, or of their right to
          privacy.<br />
          We will not be responsible, or liable to any third party, for the content or accuracy of any content posted
          by you or any other user of our platform.<br />
          The views expressed by other users on our platform do not represent our views or values. You are solely
          responsible for securing and backing up your content.
        </p>
        <h3 class="mb-2">Rights you license</h3>
        <p class="mb-custom-lg text-gray">
          When you upload or post content to our platform, you grant the following licenses:<br />
          • A worldwide, non-exclusive, royalty-free, transferable license to use, reproduce, distribute, prepare
          derivative works of, display, and perform that content in connection with the services provided by our
          platform and across different media and to promote the platform or services; and<br />
          • A worldwide, non-exclusive, royalty-free, transferable license to allow third parties to use the content
          for their purposes.<br />
          • We will only ever use your materials to carry out your instructions to us – unless, very exceptionally, a
          court or other regulator orders us to disclose them.
        </p>
      </div>
    </div>
    <div class="row align-items-center">
      <div class="col-12 col-md-6">
        <h3 class="mb-2">Viruses</h3>
        <p class="mb-custom-lg text-gray">
          We do not guarantee that our platform will be secure or free from bugs or viruses. You are responsible for
          configuring your information technology, computer programmes and platform in order to access our platform.
          You should use your own virus protection software. You must not misuse our platform by knowingly introducing
          viruses, trojans, worms, logic bombs or other material which is malicious or technologically harmful. You
          must not attempt to gain unauthorized access to our platform, the server on which our platform is stored or
          any server, computer or database connected to our platform. You must not attack our platform via a
          denial-of-service attack or a distributed denial-of service attack.
        </p>
        <h3 class="mb-2">Linking to our platform</h3>
        <p class="mb-custom-lg text-gray">
          You may link to our platform, provided you do so in a way that is fair and legal and does not damage our
          reputation or take advantage of it. You must not establish a link in such a way as to suggest any form of
          association, approval or endorsement on our part where none exists. You must not establish a link to our
          platform in any website that is not owned by you. Our platform must not be framed on any other platform. We
          reserve the right to withdraw linking permission without notice.<br />
          If you wish to make any use of content on our platform other than that set out above, please contact us at:
          contact@efun.tech
        </p>
        <h3 class="mb-2">Third party links and resources in our platform</h3>
        <p class="mb-custom-lg text-gray">
          Where our platform contains links to other sites and resources provided by third parties, these links are
          provided for your information only. We have no control over the contents of those sites or resources.
        </p>
        <h3 class="mb-2">Applicable law</h3>
        <p class="mb-custom-lg text-gray">
          If you are a consumer, please note that these terms of use, its subject matter and its formation, are
          governed by English law. If you are a business, these terms of use, its subject matter and its formation
          (and any non-contractual disputes or claims) are governed by English law.
        </p>
        <h3 class="mb-2">Contact us</h3>
        <p class="mb-custom-lg text-gray">
          To contact us, please email: <a class="text-primary-color"
            href="mailto:contact@efun.tech">contact@efun.tech</a>
        </p>
      </div>
      <div class="col-12 col-md-6">
        <div class="d-flex justify-content-md-end">
          <img class="img-fluid mb-custom-lg mb-md-0" src="https://efun-public.s3.ap-southeast-1.amazonaws.com/images/term-5.svg" alt="home item right" />
        </div>
      </div>
    </div>
  </section>
</main>
  `;
  return <div dangerouslySetInnerHTML={{ __html: html }} />;
};

export default Term;
